import React, { memo, useEffect, useState } from "react";
import { Alert, Button, Form, message, Row, Checkbox, Col, Tooltip, Switch } from "antd";
import { trans, InputDate, SelectWithSearch, AddNewButton, FieldLabel } from "@comps/components"
import "./Roster.css"

import { getErrorProps } from "@utils/helpers";

import { Const } from "../constants";
import CreateTimeSlot from '../timeSlots/components/CreateTimeSlot';
import { createSelectList } from '@comps/commonFunctions';

const days = [
  { value: 'Mon', label: 'Mon' },
  { value: 'Tue', label: 'Tue' },
  { value: 'Wed', label: 'Wed' },
  { value: 'Thu', label: 'Thu' },
  { value: 'Fri', label: 'Fri' },
  { value: 'Sat', label: 'Sat' },
  { value: 'Sun', label: 'Sun' },
];

const StepOne = memo((props) => {
  const langKey = Const["companyRoaster"].lngKey
  //========================use states start========================
  const [errors] = useState([]);
  //------------intitial steps state---------
  const [fixStartDate, setFixStartDate] = useState(null);
  const [daysOn, setDaysOn] = useState([]);
  const [autoApply, setAutoApply] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [form] = Form.useForm()
  //=======================================
  useEffect(() => {
    setData();
    // eslint-disable-next-line
  }, [props.timeSlots, props.initialValues]);

  //set props data
  //=================Submit First Step 1==============================================
  const setData = () => {
    setTimeSlots(props.timeSlots)
    if (props.initialValues) {
      setAutoApply(props.initialValues.auto_apply === true)
    }
  }

  const onSelectDays = (day) => {
    setDaysOn(day)
  }
  const onChangeStartDate = (date) => {
    setFixStartDate(date)
  }
  const onChangeEndDate = (date) => {
    let start = fixStartDate ? fixStartDate.format('YYYY-MM-DD') : null;
    let end = date ? date.format('YYYY-MM-DD') : null
    if (date !== null) {
      if (end < start) {
        message.error('End Date should be greater than start date')
        return
      }
    }
  }
  const onSubmitFirstStep = (data) => {
    if (data.end_date && data.end_date.format('YYYY-MM-DD') < data.start_date.format('YYYY-MM-DD')) {
      message.error('End Date can only be greater Than or equal to Start Date!')
      return
    }

    data.auto_apply = data.auto_apply === true;
    if (data.auto_apply) {
      data.effective_date = data.start_date.format('YYYY-MM-DD');
      data.assignment_end_date = data.end_date ? data.end_date.format('YYYY-MM-DD') : null;
    } else {
      data.effective_date = null;
      data.assignment_end_date = data.end_date ? data.end_date.format('YYYY-MM-DD') : data.start_date.format('YYYY-MM-DD');
    }

    let previewEndDate = data.end_date ? data.end_date : data.start_date;
    let dateRange = data.days && data.days.length > 0 ? getDatesRange(data.start_date, previewEndDate, data.days) : [data.start_date.format('YYYY-MM-DD')];
    //data.dates = dateRange;
    props.response(data, dateRange);
  }
  const getDatesRange = (start, end, daysOn) => {
    let startDate = start.clone ? start.clone() : start;
    let endDate = end.clone ? end.clone() : end;
    let daterange = []
    while (startDate <= endDate) {
      const day = startDate.format('dddd').substring(0, 3);
      if (daysOn.includes(day)) { //only push dates in selected days
        daterange.push(startDate.format('YYYY-MM-DD'));
      }
      startDate = startDate.add(1, 'days');
    }
    return daterange;
  }


  const onTimeSlotCreated = (data) => {
    if (data.length) {
      setTimeSlots(createSelectList(data))
      form.setFieldValue('time_slot_id', data[0].id)
    }
    setChildComponent(null);
  }
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  return (
    <>
      <Form
        // { ...formLayout } 
        layout="vertical"
        id="createRosterStepOneForm"
        name={ 'steOneForm' }
        onFinish={ onSubmitFirstStep }
        initialValues={ props.initialValues ? props.initialValues : { auto_apply: false } }
        form={ form }
      >
        <Row gutter={ 20 }>
          <Col span={ 24 }>
            <Form.Item className="create-roster-auto-apply da-mb-16">
              <div className="create-roster-switch-row">
                <Form.Item name="auto_apply" valuePropName="checked" noStyle>
                  <Switch onChange={ (checked) => setAutoApply(checked) } />
                </Form.Item>
                <Tooltip title="When this is on, the roster starts from the Effective Date and keeps applying until the End Date or until another roster starts later. If End Date is blank, Klok prepares the first 30 days and keeps the assignment active for future extension.">
                  <span className="create-roster-switch-label">Auto apply until changed</span>
                </Tooltip>
                <Tooltip title="When this is on, the roster starts from the Effective Date and keeps applying until changed.">
                  <span className="create-roster-inline-help">?</span>
                </Tooltip>
              </div>
            </Form.Item>
            <Alert
              showIcon
              type={ autoApply ? "info" : "warning" }
              message={ autoApply ? "Auto apply is on" : "Auto apply is off" }
              description={ autoApply
                ? <>Creates an effective-dated assignment. Leaving <strong>End Date</strong> blank keeps it active until a later roster overrides it.</>
                : "This creates shifts only for the selected date or date range. It will not continue after the selected dates."
              }
              className="create-roster-auto-alert"
            />
          </Col>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="start_date" rules={ rules.start_date } label={ fieldLabel(langKey, 'start_date') }
              className="da-mb-16"
              { ...getErrorProps(errors['name']) } size="small"
            >
              <InputDate
                placeholder={ autoApply ? "Select Effective Date" : "Select Roster Start Date" }
                onChange={ onChangeStartDate } />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="end_date" rules={ []} label={ fieldLabel(langKey, 'end_date') }
              className="da-mb-16"
              { ...getErrorProps(errors['name']) } size="small"
            >
              <InputDate
                placeholder={ autoApply ? "Optional End Date" : "Select Roster End Date" }
                onChange={ onChangeEndDate }
              />
            </Form.Item>
          </Col>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="days" rules={ [] } label={ fieldLabel(langKey, 'days') } className="da-mb-16"
              { ...getErrorProps(errors['name']) } size="small"
            >
              <Checkbox.Group
                className="create-roster-day-options"
                style={ { width: "100%" } }
                value={ daysOn }
                onChange={ onSelectDays }
                options={ days }
              />
            </Form.Item>
          </Col>

          { childComponent }
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <div className="klok-field-action">
              <Form.Item name="time_slot_id" rules={ rules.time_slot_id } label={ fieldLabel(langKey, 'time_slot_id') }
                className="da-mb-10"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <SelectWithSearch
                  options={ timeSlots }
                  placeholder={ trans(`${langKey}.time_slot_id`) }
                />
              </Form.Item>
              <AddNewButton className="create-roster-add-slot" text="Time Slot" onClick={ () => setChildComponent(<CreateTimeSlot onCreated={ onTimeSlotCreated } />) } />
            </div>
          </Col>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="is_full_overtime_shift" rules={ rules.is_full_overtime_shift } label={ fieldLabel(langKey, 'is_full_overtime_shift') }
              className="da-mb-10"
              { ...getErrorProps(errors['name']) } size="small"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          </Col>
        </Row>

        <div className="button-style">
          <Button className="button-next" type="primary" htmlType="submit" >Next</Button>
          {/* <Button className="button-back" disabled={ currentStep ? false : true }>Back</Button> */ }
        </div>
      </Form>
    </>
  )
})
export default StepOne
const rules = {
  start_date: [
    { required: true, message: 'Please select start date' },
  ],
  end_date: [
    { required: true, message: 'Please select end date' },
  ],
  repeat: [
    { required: true, message: 'Please enter repeat' },
  ],
  font_colour: [
    { required: true, message: 'Please enter font colour' },
  ],
  bg_colour: [
    { required: true, message: 'Please enter bg colour' },
  ],
  days: [
    { required: true, message: 'Please Select At least one day' },
  ],

  time_slot_id: [
    { required: true, message: 'Please Select Time Slot' },
  ]

};

const fieldLabel = (langKey, key) => (
  <FieldLabel
    label={ trans(`${langKey}.${key}`) }
    tooltip={ trans(`${langKey}.${key}.tooltip`) }
  />
);
